export default __webpack_public_path__ + "static/media/contact1.8569b5f4.png";